
import HeaderComponent from "../Component/HeaderComponent"
import SidebarComponent from "../Component/SidebarComponent"
import dxpaybanner from "../Assets/dxpaybanner.svg"
import suportPeople from "../Assets/icons/suportPeople.svg"
import WalletComponent from "../Component/WalletComponent"
import { useEffect, useState } from "react"
const HomePage = () => {
    const [sidebarOpen, setSiidebarOpen] = useState(false)
    const setSidebarOpen = (bool) => {
        window.localStorage.setItem('sidebarIsOpen', JSON.stringify(bool))
        setSiidebarOpen(bool)
    }
    useEffect(() => {
        const localSidebarStorage = JSON.parse(window.localStorage.getItem('sidebarIsOpen'))
        setSiidebarOpen(localSidebarStorage)

    }, [])
    return (
        <div className="w-full flex h-full   bg-[#171717]">
            <SidebarComponent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className={`${sidebarOpen?'md:ml-[250px]' : 'md:ml-[100px]'}  text-white w-full  md:mt-8  overflow-y-auto md:mt-8 text-white w-full bg-[#171717]`}>
                <HeaderComponent setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} title={'Bem vindo(a) ao Dashboard!'} subTitle={'Seja bem-vindo ao painel de controle da sua empresa'} />
                <div className="pb-4 px-4 ">
                    <img className="mt-2 w-full" src={dxpaybanner} />
                    <WalletComponent />
                    <div onClick={()=>{window.location.href=''}} className="cursor-pointer w-full mt-4 items-center gap-3 text-[#AEB9E1] flex justify-end">
                        <p className="text-[#AEB9E1]">Fale com o suporte!</p>
                        <img src={suportPeople} />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default HomePage